/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import 'moment/locale/pt';

import { 
  Box, 
  Button, 
  FormControl, 
  InputAdornment, 
  InputLabel, 
  OutlinedInput, 
  Typography,
  Select,
  MenuItem,
} from '@mui/material';
import { grey } from '@mui/material/colors';

export default function ChangeYieldAmountModal({ onClose, cupon, changeYieldAmount, setAmortization }) {
  const [value, setValue] = useState('');
  const [hasAmortization, setHasAmortization] = useState(false)
  const [isLastCupom, setIsLastCupom] = useState(false)
  const [amortizationValue, setAmortizationValue] = useState(undefined);

  const handleReturnInfos = () => {
    changeYieldAmount(value)
    setAmortization(hasAmortization ? parseFloat(amortizationValue) : null)
    onClose()
  }

  const handleChange = (event) => {
    //setValue(event);
    if (event.nativeEvent.data === ',') {
      setValue(value + '.')
    } else {
      setValue(event.target.value)
    }

  };

  function lastCupomVerify() {
    const [current, total] = cupon.current_installment.split('/')
    console.log({current, total})
    if (Number(current) === Number(total)) {
      setIsLastCupom(true)
    }
  }

  useEffect(() => {
    lastCupomVerify()
  }, [])

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Alterar valor do cupom
        </Typography>
      </Box>

      <Box sx={{
        margin: '16px',
        width: 400,
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
      }}>
        <Box sx={{
          width: '100%',
          padding: 2,
        }}>
          <Typography component="h2">
            Valor atual: {Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(cupon.amount_cpr_installment)}
          </Typography>
          <FormControl sx={{marginTop: 2, marginBottom: 2}} fullWidth>
            <InputLabel htmlFor="outlined-adornment-amount">Valor do investimento</InputLabel>
            <OutlinedInput
              id="outlined-adornment-amount"
              startAdornment={<InputAdornment position="start">R$</InputAdornment>}
              label="Valor do investimento"
              value={value === undefined ? 0 : value}
              onChange={(event) => {
                handleChange(event);
              }}
            />
          </FormControl>
          <Typography component="h2">
            Valor atualizado: {Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(value ? value : 0)}
          </Typography>
        </Box>

        {!isLastCupom && (
          <Box sx={{
          width: '100%',
          padding: 2,
          }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Possui amortização
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Possui amortização"
                value={hasAmortization}
                onChange={(e) => setHasAmortization(e.target.value)}
              >
                <MenuItem key={0} value={true}>
                  Sim
                </MenuItem>
                <MenuItem key={1} value={false}>
                  Não
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}

        {
          hasAmortization && (
            <Box sx={{
              width: '100%',
              padding: 2,
            }}>
              <FormControl sx={{marginTop: 2, marginBottom: 2}} fullWidth>
                <InputLabel htmlFor="outlined-adornment-amount2">Valor da amortização</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount2"
                  startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                  label="Valor da amortização"
                  value={amortizationValue}
                  type="number"
                  onChange={(event) => {
                    setAmortizationValue(event.target.value)
                  }}
                />
              </FormControl>
            </Box>
          )
        }
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'} onClick={() => handleReturnInfos()}>
          <Typography color={'#fff'}>
            Confirmar
          </Typography>
        </Button>
        <Button variant="contained" onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
